import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, Fragment, createElement } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime.js';
import { Button } from '@jetbrains/ring-ui/dist/button/button.js';
import cn from 'classnames';
import CloseIcon from '@jetbrains/icons/close.js';
import ChevronDownIcon from '@jetbrains/icons/chevron-down.js';
import typographyStyles from '../Typography/Typography.module.css.js';
import styles from './Notification.module.css.js';

var _excluded = ["children", "key"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Notification = function Notification(props) {
  var className = props.className,
    children = props.children,
    type = props.type,
    title = props.title,
    onClose = props.onClose,
    actions = props.actions,
    _props$collapsible = props.collapsible,
    collapsible = _props$collapsible === void 0 ? false : _props$collapsible,
    onCollapseChange = props.onCollapseChange,
    _props$isCollapsed = props.isCollapsed,
    isCollapsedProp = _props$isCollapsed === void 0 ? false : _props$isCollapsed;
  var _useState = useState(isCollapsedProp),
    _useState2 = _slicedToArray(_useState, 2),
    isCollapsed = _useState2[0],
    setIsCollapsed = _useState2[1];
  var handleToggleCollapse = function handleToggleCollapse() {
    if (onCollapseChange) {
      onCollapseChange(!isCollapsed);
    }
    setIsCollapsed(function (prev) {
      return !prev;
    });
  };
  return jsxs("div", {
    className: cn(styles.wrapper, className, styles[type]),
    "data-qd-test": props['data-qd-test'],
    children: [jsxs("div", {
      className: cn(styles.container, typographyStyles.text),
      children: [jsx("header", {
        className: cn(styles.header, _defineProperty({}, styles.isCollapsed, isCollapsed)),
        children: title
      }), !isCollapsed && jsx("div", {
        children: children
      }), onClose && !collapsible && jsx(Button, {
        className: styles.iconButton,
        onClick: onClose,
        icon: CloseIcon
      }), collapsible && jsx(Button, {
        className: cn(styles.iconButton, _defineProperty({}, styles.isCollapsed, isCollapsed)),
        onClick: handleToggleCollapse,
        icon: ChevronDownIcon,
        iconClassName: styles.chevronIcon,
        iconSize: 20
      })]
    }), actions && jsx("div", {
      className: styles.actions,
      children: actions.map(function (item) {
        if ('custom' in item) {
          return jsx(Fragment, {
            children: item.custom
          }, item.key);
        }
        var children = item.children,
          key = item.key,
          buttonProps = _objectWithoutProperties(item, _excluded);
        return /*#__PURE__*/createElement(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
          key: key,
          "data-qd-test": key
        }), children);
      })
    })]
  });
};

export { Notification };
